export default {
  OWNER: 'owner',
  CO_OWNER: 'co-owner',
  CONTRIBUTOR: 'contributor',
  VIEWER: 'viewer',
  REMOVE: 'remove',
};
